export const clearAccountLocalData = () => {
  try {
    window.sessionStorage.removeItem('thetavern.headerProfile');
  } catch {}

  try {
    Object.keys(window.localStorage)
      .filter((key) => key.startsWith('thetavern:night-draft:v1'))
      .forEach((key) => window.localStorage.removeItem(key));
  } catch {}
};
